import {defineMessages} from 'react-intl'

export const country = defineMessages({
  'seoMeta.countryHeading': {
    id: 'seoMeta.countryHeading',
    defaultMessage: 'Hotels & accommodation in {country}'
  },
  'seoMeta.countryDescription': {
    id: 'seoMeta.countryDescription',
    defaultMessage:
      'Find and compare hotels in {country}. Get trusted rates, reviews and easy booking with Vio.com.'
  },
  'seoMeta.countryAttrHeading': {
    id: 'seoMeta.countryAttrHeading',
    defaultMessage: '{hotels} in {country}'
  },
  'seoMeta.countryAttrDescription': {
    id: 'seoMeta.countryAttrDescription',
    defaultMessage: 'Filter by what matters and book the right stay on Vio.com.'
  }
})

const city = defineMessages({
  'seoMeta.cityHeading': {
    id: 'seoMeta.cityHeading',
    defaultMessage: 'Hotels in {city}'
  },
  'seoMeta.cityDescription': {
    id: 'seoMeta.cityDescription',
    defaultMessage:
      'Compare hotels in {city}. Check location, reviews and prices, then book with Vio.com.'
  },
  'seoMeta.cityAttrHeading': {
    id: 'seoMeta.cityAttrHeading',
    defaultMessage: '{hotels} in {city}'
  },
  'seoMeta.cityAttrDescription': {
    id: 'seoMeta.cityAttrDescription',
    defaultMessage: 'Filter by what matters and book the right stay on Vio.com.'
  }
})

const landmark = defineMessages({
  'seoMeta.landmarkHeading': {
    id: 'seoMeta.landmarkHeading',
    defaultMessage: 'Hotels near {landmark}, {city}'
  },
  'seoMeta.landmarkDescription': {
    id: 'seoMeta.landmarkDescription',
    defaultMessage:
      'Stay close to {landmark} in {city}. Compare nearby hotels and book at the best price on Vio.com.'
  },
  'seoMeta.landmarkAttrHeading': {
    id: 'seoMeta.landmarkAttrHeading',
    defaultMessage: '{hotels} near {landmark}, {city}'
  },
  'seoMeta.landmarkAttrDescription': {
    id: 'seoMeta.landmarkAttrDescription',
    defaultMessage: 'Compare comfort, distance and price on Vio.com.'
  }
})

export const translations = {
  ...country,
  ...city,
  ...landmark
}
